"use client";

import React, { useState } from "react";
import classNames from "classnames";
import { CardBox } from "../CardBox";
import { TabsProps } from "./types";

import { Picker } from "../Picker";
import { PickerProps } from "../Picker/types";
import { Accordion, Select } from "@npm_leadtech/qr-ui-components";
import { Typography } from "../Typography";
import "./styles.scss";

export const Tabs = ({ tabsData, light, className }: TabsProps) => {
  const classnames = classNames(`tabs`, {
    ["tabs--light"]: light,
    ["tabs--left"]: tabsData[0].position === "left",
    [`${className}`]: className,
  });

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_selectedOption, setSelectedOption] = useState<string | string[]>(undefined);
  const [activeTab, setActiveTab] = useState<number>(0);

  const selectOptions = tabsData.map((tab, i) => ({
    value: String(i),
    label: tab.label,
  }));

  const renderTabByType = (tab) => {
    let tabContent;
    tab.type === "form" ? (tabContent = tab.content as PickerProps) : (tabContent = tab.content);

    switch (tab.type) {
      case "accordion":
        return (
          <>
            {Array.isArray(tab.content) &&
              tab.content.map((item, i) => (
                <Accordion
                  key={i}
                  title={item.title}
                  defaultExpanded={i === 0}
                >
                  {item.richtext.map((item, i) => (
                    <Typography
                      key={i}
                      Tag={item.tag}
                    >
                      {item.content}
                    </Typography>
                  ))}
                </Accordion>
              ))}
          </>
        );
      case "form":
        return (
          <>
            <div
              className={tabContent.className}
              id={tabContent.id}
            >
              <Picker
                options={tabContent.options}
                selector={tabContent.selector}
                onClick={setSelectedOption}
              />
            </div>
          </>
        );
      default:
        return (
          <>
            {!Array.isArray(tab.content) ? (
              <p>{tabContent}</p>
            ) : (
              <div>
                {Array.isArray(tab.content) &&
                  tab.content.map((item, i) => (
                    <CardBox
                      item={item}
                      key={i}
                    />
                  ))}
              </div>
            )}
          </>
        );
    }
  };

  return (
    <div
      className={classnames}
      data-testid="Tabs"
    >
      {tabsData.map((tab, i) => (
        <React.Fragment key={i}>
          <input
            type="radio"
            name="tabset"
            id={`tab-${tab.id}`}
            aria-controls={tab.label}
            checked={activeTab === i}
            onChange={() => setActiveTab(i)}
            className="tabs-input"
          />
          <label
            htmlFor={`tab-${tab.id}`}
            className={`tabs-label ${tab.style ? "tab-label--rounded" : ""}`}
          >
            {tab.label}
            <span className="subLabel"> {tab.subLabel}</span>
          </label>
        </React.Fragment>
      ))}

      <div className="tabs-select-wrapper">
        <Select
          multiple={false}
          options={selectOptions}
          value={String(activeTab)}
          onChange={(val) => setActiveTab(Number(val))}
        />
      </div>

      <div className="tab-panels">
        {tabsData?.map((tab, i) => {
          return (
            <section
              id={`tab-panel-${i}`}
              className="tab-panel"
              key={i}
            >
              <>{renderTabByType(tab)}</>
            </section>
          );
        })}
      </div>
    </div>
  );
};
